'use strict';
import React from 'react';
import classNames from 'classnames';

/**
 * TextArea component.
 * InputField-textArea should be used for textarea elements.
 * InputField-textArea supports focus and disabled states and has a InputField-textArea--error variant.
 *
 * Usage:
 *
 * ```Javascript
 * <InputLabel label="name" for="model-name">
 *   <InputValidation>{model.errors.name}</InputValidation>
 *   <TextArea name="name" id="model-name" error/>
 * </InputLabel>
 * ```
 *
 * @extends {React.Component}
 * @property {Boolean} error Renders the TextArea with the InputField-textArea--error class.
 * @property {Boolean} disabled Renders the TextArea as disabled.
 */
class TextArea extends React.Component {

  /**
   * @return {JSX} JSX component markup.
   */
  render () {
    const { disabled, error, ...otherProps } = this.props;
    const classes = classNames({
      'InputField-textArea': true,
      'InputField-textArea--error': error,
      'is-disabled': disabled
    });

    return (
      <textarea {...otherProps}
        className={classes}
        disabled={disabled}>
      </textarea>
    );
  }
}

/**
 * @prop {propTypes} propTypes - required attributes for the TextArea component
 */
TextArea.propTypes = {
  disabled: React.PropTypes.bool,
  error: React.PropTypes.bool
};

TextArea.defaultProps = {
  disabled: false,
  error: false
};

export default TextArea;



// WEBPACK FOOTER //
// ./src/components/clarity-ui/inputs/textArea.jsx